import classNames from 'classnames'
import React from 'react'

import { ButtonSize, noop } from '@ds'

import styles from './IconButton.module.scss'

interface IconButtonProps {
  size?: ButtonSize
  disabled?: boolean
  onClick?: () => void
  leftIcon?: React.ReactNode
  rightIcon?: React.ReactNode
  children?: React.ReactNode
  className?: string
  type?: 'primary' | 'secondary'
}

export const IconButton: React.FC<IconButtonProps> = ({
  size = 'S',
  disabled = false,
  onClick,
  children,
  leftIcon,
  rightIcon,
  className,
  type = 'primary',
}) => {
  const isRound = !children && (leftIcon || rightIcon)

  const buttonClass = classNames(
    styles.button,
    styles[size],
    {
      [styles.disabled]: disabled,
      [styles.round]: isRound,
      [styles.paddingRight]: !rightIcon,
      [styles.paddingLeft]: !leftIcon,
      [styles.primary]: type === 'primary',
    },
    className
  )

  return (
    <button
      className={buttonClass}
      onClick={disabled ? noop : onClick}
      disabled={disabled}
    >
      {leftIcon && <span className={styles.icon}>{leftIcon}</span>}
      {children}
      {rightIcon && <span className={styles.icon}>{rightIcon}</span>}
    </button>
  )
}
